import { TRIGGER_RATE_TRANSACTION_API, TRIGGER_RATE_TRANSACTION_API_SUCCESS } from 'redux/actionTypes';
export function triggerRateTransactionApi(data, stopLoader) {
	return {
		type: TRIGGER_RATE_TRANSACTION_API,
		data,
		stopLoader,
	};
}

export function triggerRateTransactionApiSuccess(data) {
	return {
		type: TRIGGER_RATE_TRANSACTION_API_SUCCESS,
		data,
	};
}
